import { render, staticRenderFns } from "./CmgBasicErrorModal.vue?vue&type=template&id=2c027bd1&scoped=true&lang=pug&"
import script from "./cmg-basic-error-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-basic-error-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgBasicErrorModal.vue?vue&type=style&index=0&id=2c027bd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c027bd1",
  null
  
)

export default component.exports